/* ─────────────────────────────────────────────────────────────────────────────
   whatsapp-co.js — EL BOTÓN DE WHATSAPP, NATIVO (dictado del dueño 08-sep, §11)

   QUÉ REEMPLAZA: la app «WhatsApp Button» ($0,89/30d). Su botón vive dentro del
   shadow DOM de un custom element (`<gty-whatsapp-chat-button>`), medido en vivo el
   09-sep en el duplicado: el envoltorio interno es `position:fixed; bottom:111px;
   right:10px; z-index:9999`, con un círculo de 48x48 px visuales (64 px escalados a
   .75), fondo #BD7F60 y glifo oscuro, y su enlace es `https://wa.me/573148533849`
   SIN mensaje prellenado. Aquí se pinta el mismo círculo, con el mensaje puesto.

   ⚠️ CORRECCIÓN AL PLANTEAMIENTO DE LA NOTA, y es lo que hace que esto funcione:
   la nota pedía meter el círculo DENTRO de la barra adhesiva del botón COD. Medido
   en el duplicado, esa barra (`[data-lb-sticky-offers]`) se ESCONDE y se muestra con
   el scroll (`opacity:0` + `translateY(+82px)` cuando no toca) y en escritorio no
   existe (su CSS vive en `@media (max-width:899px)`): un WhatsApp colgado de ella
   desaparecería justo cuando el cliente lo busca. Se hace al revés: UN solo elemento
   fijo, siempre visible, cuyo `bottom` se MIDE contra la barra. Así «se mueve con
   ella» (nota §11) y nunca la tapa (última línea de la nota: «convive sin taparse
   con el sticky (medir)»).

   🔒 SI ESTO FALLA, EL BOTÓN DE LA APP SIGUE AHÍ. La regla que apaga la app cuelga de
   la clase `cco-wa-on`, que se estampa en <html> sólo cuando el nuestro ya está en el
   DOM. Ocultar la app desde el CSS a secas dejaría la tienda SIN NINGÚN WhatsApp el
   día que este archivo no cargue o el número venga vacío — y perder el canal de
   contacto es peor que pagar $0,89. (La app se desinstala cuando el duplicado esté
   publicado y verificado, nota §14.)

   🔒 EL NÚMERO NO VIVE AQUÍ: llega desde `layout/theme.liquid` (#cco-wa-cfg), que es
   donde ya está escrito a mano el mismo +57 314 853 3849 en los ajustes del tema
   (bloque de texto del footer). Un solo sitio donde cambiarlo.

   Sin red, sin dependencias, sin temporizadores: sólo dos escuchas de eventos y un
   MutationObserver sobre la barra.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  // Guard de doble inclusión: si alguien deja la etiqueta puesta dos veces (o la app
  // de un tema hijo la repite), dos círculos apilados se ven como un error.
  if (document.querySelector('.cco-wa')) return;

  var cfg = {};
  try {
    var nodo = document.getElementById('cco-wa-cfg');
    if (nodo) cfg = JSON.parse(nodo.textContent) || {};
  } catch (e) { cfg = {}; }

  // Sólo dígitos: wa.me no acepta espacios ni «+». Si no hay número no se inventa
  // ninguno — un enlace a wa.me sin destino abre una pantalla de error.
  var numero = String(cfg.numero || '').replace(/\D/g, '');
  if (!numero) return;

  var prod = String(cfg.producto || '').trim();
  var texto = prod
    ? 'Hola, tengo una pregunta sobre ' + prod
    : 'Hola, tengo una pregunta';

  var a = document.createElement('a');
  a.className = 'cco-wa';
  a.href = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(texto);
  a.target = '_blank';
  a.rel = 'noopener';
  a.setAttribute('aria-label', 'Escríbenos por WhatsApp');
  // El glifo, en línea: una imagen externa sería una petición más y un hueco visible
  // mientras carga. `currentColor` para que el color lo mande el CSS.
  a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15'
    + '-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475'
    + '-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.347-.347.52-.52'
    + '.174-.174.232-.298.347-.497.115-.198.058-.371-.014-.52-.072-.148-.669-1.611-.916-2.207'
    + '-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372'
    + '-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487'
    + '.709.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413'
    + '.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004'
    + 'a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374'
    + 'a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898'
    + 'a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884'
    + 'm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892'
    + 'c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005'
    + 'c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';
  document.body.appendChild(a);
  // Recién ahora se apaga el de la app: ver el candado de la cabecera.
  document.documentElement.classList.add('cco-wa-on');

  // ── EL CÍRCULO SE MUEVE CON LA BARRA ADHESIVA ────────────────────────────────
  // La barra se considera PRESENTE sólo si de verdad se ve. Tres señales, porque el
  // mecanismo mexicano la esconde sin quitarla del flujo (medido: `display:flex`,
  // `opacity:0`, `transform:translateY(+82px)` → su borde superior queda EXACTAMENTE
  // en `innerHeight`). Con una sola señal el círculo se quedaría subido para siempre.
  var BASE = 20;      // sin nada abajo: donde está hoy el de la app, abajo-derecha
  var HUECO = 12;     // aire entre el círculo y lo que tenga debajo
  var observando = false;

  // Alto de un elemento SÓLO si de verdad se ve. Tres señales, porque el mecanismo
  // mexicano esconde la barra sin quitarla del flujo (medido: `display:flex`,
  // `opacity:0`, `transform:translateY(+82px)` → su borde superior queda EXACTAMENTE
  // en `innerHeight`). Con una sola señal el círculo se quedaría subido para siempre.
  function altoVisible(el) {
    if (!el || el.hidden) return 0;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return 0;
    var r = el.getBoundingClientRect();
    if (!(r.height > 0)) return 0;
    if (!(r.top < window.innerHeight)) return 0;   // trasladado fuera de la pantalla
    return r.height;
  }

  function estorboAbajo() {
    var st = document.querySelector('[data-lb-sticky-offers]');
    // ⚠️ TAREA ADHESIVO (dueño 11-sep): la MISMA jugada para la barra "Agregar al
    // carrito" de las fichas NORMALES (`sticky-atc-co.js`, `.satc-bar`). No hace
    // falta una señal aparte: esa barra se oculta con `transform: translateY(120%)`
    // (nunca `display`/`opacity`), así que su borde superior queda FUERA de
    // `innerHeight` cuando está escondida y DENTRO cuando se muestra — `altoVisible`
    // ya lo detecta sin cambios. Las dos barras son mutuamente excluyentes por el
    // gate de Liquid (2x1 vs. ficha normal), pero por si algún día conviven, el
    // `Math.max` de abajo las cubre a las dos sin preferir una.
    var sa = document.querySelector('.satc-bar');
    if ((st || sa) && !observando) {          // las barras pueden llegar después que nosotros
      observando = true;
      try {
        if (st) {
          new MutationObserver(recolocar).observe(st, {
            attributes: true, attributeFilter: ['hidden', 'class', 'style'],
          });
        }
        if (sa) {
          new MutationObserver(recolocar).observe(sa, {
            attributes: true, attributeFilter: ['class', 'style'],
          });
        }
      } catch (e) { /* sin observador quedan el scroll y el transitionend */ }
      // Las dos barras aparecen y desaparecen con transición: sin esto, al soltar
      // el scroll el círculo se queda arriba hasta el siguiente movimiento del dedo.
      if (st) st.addEventListener('transitionend', recolocar);
      if (sa) sa.addEventListener('transitionend', recolocar);
    }
    // ⚠️ Y LA BARRA DE VISTA PREVIA DE SHOPIFY, que NO existe en la tienda pero SÍ en
    //    el único sitio donde el dueño revisa esto (nota §14: se trabaja sobre un
    //    duplicado y se mira por vista previa). Mide 68 px, va pegada abajo y con el
    //    círculo a 20 px lo tapaba entero en las 57 fichas que no llevan barra
    //    adhesiva — o sea que el botón se reportaría como roto sin estarlo. En
    //    producción este elemento no existe, así que aquí no cambia nada.
    var pv = document.getElementById('PBarNextFrameWrapper');
    return Math.max(altoVisible(st), altoVisible(sa), altoVisible(pv));
  }

  function recolocar() {
    var alto = estorboAbajo();
    var b = alto ? Math.round(alto) + HUECO : BASE;
    document.documentElement.style.setProperty('--cco-wa-bottom', b + 'px');
  }

  recolocar();
  addEventListener('scroll', recolocar, { passive: true });
  addEventListener('resize', recolocar);
})();
